import { Box, Button, Flex, Stack, Text } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Sidebar = ({ onLogout, isLoading }) => {
  const { user } = useAuth();

  const links = [
    { to: '/dashboard', label: 'Dashboard', visible: true },
    { to: '/reports', label: 'Reports', visible: user?.permissions?.articles?.view },
    { to: '/transactions', label: 'Transactions', visible: user?.permissions?.transactions?.view },
    { to: '/clients', label: 'Clients', visible: user?.permissions?.clients?.view },
    { to: '/articles', label: 'Articles', visible: user?.permissions?.articles?.view },
    { to: '/ledger', label: 'Ledger', visible: user?.permissions?.articles?.view },
    { to: '/vadla', label: 'Vadla', visible: user?.permissions?.articles?.view },
    { to: '/master', label: 'Master', visible: user?.role === 'admin' }
  ];

  return (
    <Flex
      direction="column"
      bg="white"
      borderRight="1px solid"
      borderColor="gray.200"
      w={{ base: 'full', md: 64 }}
      minH="100vh"
      p={6}
      gap={8}
    >
      <Box>
        <Text fontSize="xl" fontWeight="bold" color="blue.600">
          Girvi Riddhi
        </Text>
        <Text fontSize="sm" color="gray.500">
          Business Management
        </Text>
        {user && (
           <Text fontSize="xs" mt={1} color="gray.400">
             Logged in as: {user.username} ({user.role})
           </Text>
        )}
      </Box>
      <Stack spacing={2} flex={1}>
        {links.filter(l => l.visible !== false).map(link => (
          <Button
            as={NavLink}
            key={link.to}
            to={link.to}
            variant="ghost"
            justifyContent="flex-start"
            _activeLink={{ bg: 'blue.50', color: 'blue.700' }}
          >
            {link.label}
          </Button>
        ))}
      </Stack>
      <Button colorScheme="red" variant="outline" onClick={onLogout} isLoading={isLoading}>
        Logout
      </Button>
      
      {/* Footer Info */}
      <Box pt={4} borderTop="1px solid" borderColor="gray.200">
        <Text fontSize="xs" fontWeight="bold" color="gray.600">
          Powered by Riddhi Infotech
        </Text>
        <Text fontSize="xs" color="gray.500" mt={1}>
          <a href="http://www.riddhi-infotech.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>
            www.riddhi-infotech.com
          </a>
        </Text>
        <Text fontSize="xs" color="gray.500">
          Mob: 7499391121
        </Text>
      </Box>
    </Flex>
  );
};

export default Sidebar;
